export default __webpack_public_path__ + "static/media/hero_logo.950f7be4.png";